module.exports = __webpack_public_path__ + "img/fun.fb33d6cf.png";